<template>
  <v-dialog persistent scrollable width="700px" style="backdrop-filter: blur(5px)">
    <template v-slot:activator="{ props: activatorProps }">
      <v-list-item link v-bind="activatorProps">
        <template v-slot:append>
          <v-icon :icon="['fas', 'file']" />
        </template>
        СОЗДАТЬ ТОиППР
      </v-list-item>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card rounded="xl">
        <template v-slot:prepend>
          <v-img id="g_logo" src="https://media.scgrdn.pro/global/logotypes/guardian/guardian.png" width="200" />
        </template>

        <template v-slot:title>
          <p>ПОДТВЕРДИТЕ ДЕЙСТВИЕ</p>
        </template>
        <template v-slot:subtitle>
          <p>ФОРМИРОВАНИЕ ТОиППР</p>
        </template>
        <template v-slot:append>
          <v-btn
              :disabled="creating"
              flat
              color="deep-orange"
              variant="tonal"
              :icon="true"
              @click="isActive.value = false"
          >
            <v-icon :icon="['fas', 'xmark']" />
          </v-btn>
        </template>
        <template v-slot:text>
          <v-alert v-if="all_for_one" color="deep-orange" class="mb-4" rounded="xl">
            <template v-slot:title>
              ВНИМАНИЕ
            </template>
            <template v-slot:text>
              Вы выбрали вариант формирования документов ТОиППР для всего вашего подразделения, убедитесь в том, что Ваши коллеги закончили планирование!
              <v-checkbox :disabled="creating" v-model="confirmation" label="ПОДТВЕРЖДАЮ" color="white" hide-details hide-spin-buttons />
            </template>
          </v-alert>
          <v-radio-group :disabled="creating" v-model="all_for_one" v-on:update:model-value="confirmation = false">
            <v-radio :value="false" :label="`Формирую ТОиППР только за ${(filters && filters.chiefs) ? 'другого пользователя (см. Фильтры)' : 'себя'}`" />
            <v-radio :value="true" label="Формирую ТОиППР для всего подразделения" />
          </v-radio-group>
        </template>
        <template v-slot:actions>
          <v-btn block variant="tonal" rounded="xl" flat color="light-green" :disabled="(all_for_one && !confirmation) || creating" v-on:click="create_toppr()">
            СФОРМИРОВАТЬ
          </v-btn>
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { Allerts } from "@/store/global/Allerts";
import { QuarterStatus } from "@/store/zn_planner/QuarterStatus";
import { CurrentYear } from "@/store/zn_planner/CurrentYear";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { ZN_Filters } from "@/store/zn_planner/Filters";

export default {
  name: 'ZN_TOnPPR',
  data() {
    return {
      all_for_one: false,
      confirmation: false,
      creating: false
    }
  },
  methods: {
    get_user_name: function () {

    },
    create_toppr: async function() {
      this.creating = true
      let raw = {
        district: this.district,
        quarter: this.quarter,
        year: this.year,
        for_all: this.all_for_one
      }
      if (this.filters && this.filters.chiefs) {
        raw.chief = this.filters.chiefs
      }

      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/ZN_CreateTOPPR`
      let props = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, props)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка создания документов ТОиППР!`
            }
          })
          .then(result => {
            console.log(result)
            if (result && result.length > 0) {
              Allerts().warn('УСПЕХ!', `${result.length} документов уже имеют экземпляр и НЕ были созданы повторно! Оставшиеся успешно созданы!`, '#e3ab32', 'check')
            } else {
              Allerts().warn('УСПЕХ!', `Документы ТОиППР успешно созданы!`, '#68b616', 'check')
            }
            location.reload();
          }).catch(err => {
            Allerts().warn('ОШИБКА!', `${err}`, '#ff4422', 'triangle-exclamation')
            console.error(err)
            this.creating = false
          })
    },
  },
  computed: {
    filters: {
      get() {
        return ZN_Filters().get()
      },
      set(value) {
        ZN_Filters().set(value)
      }
    },
    quarter() {
      return parseInt(this.$route.params.quarter)
    },
    district() {
      return this.$route.params.guid
    },
    year: {
      get() {
        return CurrentYear().get()
      },
      set(value) {
        CurrentYear().set(value)
      }
    },
    q_stat: {
      get() {
        return QuarterStatus().get()
      },
      set(value) {
        QuarterStatus().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}

</script>

<style scoped>
.text-to {
  color: #8b3f00;
}

.text-isp {
  color: #85d91f;
}

.unknown {
  color: #000000;
}
.doc-text {
  font-size: 10px;
}

.is_weekend {
  background: #efefef;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNHB4IiBoZWlnaHQ9IjRweCIgdmlld0JveD0iMCAwIDQgNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNCA0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0FCQUJBQiIgc3Ryb2tlLXdpZHRoPSIwLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgeDE9IjAiIHkxPSIwIiB4Mj0iNCIgeTI9IjQiLz4NCjwvc3ZnPg0K");
  background-repeat: repeat;
  background-position: 0 0;
}
</style>
